/**
 * Helpers for email/password auth UI — kept tiny on purpose.
 * Used by SignIn / SignUp / VerifyEmail / ForgotPassword / ResetPassword.
 */

/**
 * FastAPI 422 responses return `detail` as an array of `{msg, loc, ...}` objects,
 * not a string. Rendering that array directly in JSX crashes React with
 * "Objects are not valid as a React child". Always pass `err?.response?.data?.detail`
 * through this before showing it.
 */
export function formatApiErrorDetail(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  }
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Returns a list of human-readable issues (empty list = valid). */
export function validatePassword(pw) {
  const issues = [];
  if (!pw || pw.length < 8) issues.push("at least 8 characters");
  if (!/[A-Za-z]/.test(pw)) issues.push("a letter");
  if (!/[0-9]/.test(pw)) issues.push("a number");
  return issues;
}

/** Basic email shape check — backend does the real validation. */
export function isLikelyEmail(s) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || "").trim());
}
